import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output() sidebarToggle = new EventEmitter<boolean>();
  searchFormOpened: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  sidebarOpen() {
    this.sidebarToggle.emit(true);
  }

  searchFormOpen(searchForm) {
    this.searchFormOpened = true;
    searchForm.focus();
    console.log(searchForm);
  }

}



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/layout/header/header.component.ts